module.exports = __webpack_public_path__ + "static/media/grc.c49461c7.svg";